<template>
  <div>
    <div class="div-publicSessionPageHeaderSection">
      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="6">
            <v-img
              :aspect-ratio="12 / 9"
              :src="sessionDetails.headerImage"
              lazy-src="/image-placeholder.png"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular
                    indeterminate
                    color="#5c648b"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col cols="12" sm="6">
            <v-col md="12" cols="12"
              ><span class="span-date">{{
                sessionDetails.dateToFrom
              }}</span></v-col
            >
            <v-col md="12" cols="12">
              <div class="div-title">
                <span class="span-title">{{ sessionDetails.title }}</span>
              </div>
            </v-col>
            <v-col cols="12">
              <span class="span-subTitle">{{ sessionDetails.subTitle }}</span>
            </v-col>
            <v-col align="right" cols="12" class="div-enrollNowButton">
              <v-btn
                class="btn-enrollNow"
                :loading="paymentLoading"
                @click="
                  () => {
                    selectedSession = null;
                    enrollForSession();
                  }
                "
              >
                Enroll Now
              </v-btn>
            </v-col>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="div-publicSessionPageDetailSection">
      <v-container>
        <v-row>
          <v-col cols="12" class="rightContainer" v-if="$store.state.isMobile">
            <div class="div-detailCard">
              <span class="span-title">Price</span>
              <span class="span-priceSubTitle">
                {{ details.is_free ? ` FREE ` : `₹ ` + details.amount }}
              </span>
            </div>
            <div class="div-detailCard">
              <span class="span-title">Hosted by</span>
              <span class="span-subTitle">{{ sessionDetails.hostedBy }}</span>
            </div>
            <div class="div-detailCard">
              <span class="span-title">Where</span>
              <span class="span-subTitle">Online</span>
            </div>
            <div class="div-detailCard">
              <span class="span-title">Share this Batch</span>
              <v-row align="center" class="ma-0">
                <v-btn
                  v-if="$store.state.isMobile"
                  class="ms-2"
                  icon
                  :href="whatsappUrl"
                  data-action="share/whatsapp/share"
                  target="_blank"
                >
                  <v-icon color="#039687" size="32">mdi-whatsapp</v-icon>
                </v-btn>
                <v-btn class="ms-2" icon @click="facebookShare">
                  <v-icon color="#2d88ff" size="32">mdi-facebook</v-icon>
                </v-btn>
                <v-btn class="ms-2" icon @click="twitterShare">
                  <v-icon color="#1da2f1" size="32">mdi-twitter</v-icon>
                </v-btn>
                <v-btn class="ms-2" icon @click="emailShare">
                  <v-icon color="#506CFF" size="32">mdi-email-outline</v-icon>
                </v-btn>
              </v-row>
              <div class="div-copyLinkTextField">
                <v-text-field
                  suffix="..."
                  readonly
                  hide-details
                  outlined
                  append-icon="mdi-content-copy"
                  @click:append="copyParentLink"
                  :value="makePublicLink()"
                ></v-text-field>
              </div>
              <div class="div-OR">or</div>
              <div class="div-inviteViaEmailButton">
                <v-btn class="btn-inviteViaEmail" depressed @click="emailShare"
                  >Invite via Email</v-btn
                >
              </div>
            </div>
          </v-col>
          <v-col md="9" cols="12" class="leftContainer">
            <v-row>
              <v-col md="2" cols="12" class="title">Details</v-col>
              <v-col
                md="10"
                cols="12"
                class="para-batchDetails contentOverflow"
                v-html="sessionDetails.detail"
              />
              <v-col md="2" cols="12" class="div-title">
                <span class="span-title">Special Educator</span>
                <v-avatar color="primary" size="72">
                  <img
                    :src="sessionDetails.educatorImage"
                    alt="Educator Image"
                  />
                </v-avatar>
              </v-col>
              <v-col md="10" cols="12">
                <span class="span-educatorName">{{
                  sessionDetails.educatorName
                }}</span>
                <p class="para-specialEducatorDetails">
                  {{ sessionDetails.educatorBio }}
                </p>
              </v-col>
              <v-col md="2" cols="12" class="title">Skills</v-col>
              <v-col md="10" cols="12" class="skillDetails">
                <span
                  v-for="(skill, i) in sessionDetails.skills"
                  :key="skill.name + i"
                >
                  {{
                    sessionDetails.skills.length - 1 > i
                      ? skill.name + ", "
                      : skill.name
                  }}
                </span>
              </v-col>
              <v-col md="2" cols="12" class="title">Age Group</v-col>
              <v-col md="10" cols="12" class="skillDetails">
                <span
                  v-for="(skill, i) in sessionDetails.ageGroup"
                  :key="skill.name + i"
                >
                  {{
                    sessionDetails.ageGroup.length - 1 > i
                      ? skill.name + ", "
                      : skill.name
                  }}
                </span>
              </v-col>
              <v-col md="2" cols="12" class="title">Tags</v-col>
              <v-col md="10" cols="12">
                <v-chip
                  small
                  class="me-2"
                  v-for="(tag, i) in sessionDetails.tags"
                  :key="i"
                  >{{ tag.name }}</v-chip
                >
              </v-col>

              <v-col cols="12"
                ><v-divider
                  style="border: 1px solid rgba(0, 0, 0, 0.16)!important;"
                ></v-divider
              ></v-col>

              <v-col
                cols="12"
                class="contentOverflow"
                v-html="details.final_pitch"
              >
                <!--                <div  style="overflow: hidden"-->
                <!--                  v-html="details.final_pitch"-->
                <!--                />-->
              </v-col>
            </v-row>
          </v-col>
          <v-col
            md="3"
            cols="12"
            class="rightContainer"
            v-if="!$store.state.isMobile"
          >
            <div class="div-detailCard">
              <span class="span-title">Price</span>
              <span class="span-priceSubTitle">{{
                details.is_free ? ` FREE ` : `₹ ` + details.amount
              }}</span>
            </div>
            <div class="div-detailCard">
              <span class="span-title">Hosted by</span>
              <span class="span-subTitle">{{ sessionDetails.hostedBy }}</span>
            </div>
            <div class="div-detailCard">
              <span class="span-title">Where</span>
              <span class="span-subTitle">Online</span>
            </div>
            <div class="div-detailCard">
              <span class="span-title">Share this Batch</span>
              <v-row align="center" class="ma-0">
                <v-btn
                  v-if="$store.state.isMobile"
                  class="ms-2"
                  icon
                  :href="whatsappUrl"
                  data-action="share/whatsapp/share"
                  target="_blank"
                >
                  <v-icon color="#039687" size="32">mdi-whatsapp</v-icon>
                </v-btn>
                <v-btn class="ms-2" icon @click="facebookShare">
                  <v-icon color="#2d88ff" size="32">mdi-facebook</v-icon>
                </v-btn>
                <v-btn class="ms-2" icon @click="twitterShare">
                  <v-icon color="#1da2f1" size="32">mdi-twitter</v-icon>
                </v-btn>
                <v-btn class="ms-2" icon @click="emailShare">
                  <v-icon color="#506CFF" size="32">mdi-email-outline</v-icon>
                </v-btn>
              </v-row>
              <div class="div-copyLinkTextField">
                <v-text-field
                  suffix="..."
                  readonly
                  hide-details
                  outlined
                  append-icon="mdi-content-copy"
                  @click:append="copyParentLink"
                  :value="makePublicLink()"
                ></v-text-field>
              </div>
              <div class="div-OR">or</div>
              <div class="div-inviteViaEmailButton">
                <v-btn class="btn-inviteViaEmail" depressed @click="emailShare">
                  Invite via Email
                </v-btn>
              </div>
            </div>
          </v-col>

          <v-col cols="12"
            ><v-divider
              style="border: 1px solid rgba(0, 0, 0, 0.16)!important;"
            ></v-divider
          ></v-col>

          <v-col class="div-sectionHeading" cols="12">Sessions</v-col>
          <v-row class="row-sessions" justify="center" style="width: 100%">
            <v-col
              :key="index"
              sm="4"
              cols="10"
              class="col-session"
              v-for="(session, index) in sessionDetails.sessionsList"
            >
              <v-card class="card-session" height="498px" flat>
                <v-img
                  contain
                  :aspect-ratio="12 / 9"
                  :src="session.thumbnailPath"
                  lazy-src="/image-placeholder.png"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#5c648b"
                      ></v-progress-circular>
                    </v-row> </template
                ></v-img>
                <div class="px-6 py-3" style="height: 100%;">
                  <span class="span-cardTitle">{{ session.title }}</span>
                  <span class="span-cardSubTitle">{{ session.dates }}</span>
                  <div
                    class="div-cardContent contentOverflow"
                    style="overflow-y: auto;height: 44%;"
                    v-html="session.abstract"
                  ></div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-col cols="12"
            ><v-divider
              style="border: 1px solid rgba(0, 0, 0, 0.16)!important;"
            ></v-divider
          ></v-col>

          <v-col class="div-sectionHeading" cols="12">
            Offer Details and Pricing
          </v-col>
          <v-row class="row-offerDetailsAndPricing" justify="center">
            <v-col md="4" cols="10" class="col-offerDetailsAndPricing">
              <v-card class="card-offerDetailsAndPricing" flat>
                <div class="div-cardContent">
                  <div class="div-cardHeader">
                    <span class="span-cardTitle" style="">{{
                      sessionDetails.offerAndPricing.allSessions.title
                    }}</span>
                    <span class="span-cardSubTitle" v-if="!details.is_free">
                      ₹ {{ sessionDetails.offerAndPricing.allSessions.price }}
                    </span>
                    <span v-else class="span-cardSubTitle">
                      Free
                    </span>
                  </div>
                  <ul>
                    <li
                      :key="index"
                      v-for="(ele, index) in sessionDetails.offerAndPricing
                        .allSessions.abstract"
                    >
                      <v-icon>mdi-check</v-icon>{{ ele }}
                    </li>
                  </ul>
                </div>
                <v-card-actions>
                  <v-btn
                    depressed
                    class="btn-payAndEnroll"
                    :loading="buySessionSeriesLoading"
                    @click="
                      () => {
                        selectedSession = null;
                        buySessionSeriesLoading = true;
                        enrollForSession();
                      }
                    "
                  >
                    Pay & Enroll
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              md="4"
              cols="10"
              class="col-offerDetailsAndPricing"
              v-if="selectSessionList.length > 0"
            >
              <v-card class="card-offerDetailsAndPricing" flat>
                <div class="div-cardContent">
                  <div class="div-cardHeader">
                    <span class="span-cardTitle" style="">
                      {{
                        sessionDetails.offerAndPricing.individualSession.title
                      }}
                    </span>
                    <span class="span-cardSubTitle" v-if="!details.is_free">
                      ₹
                      {{
                        sessionDetails.offerAndPricing.individualSession.price
                      }}
                    </span>
                    <span v-else class="span-cardSubTitle">
                      Free
                    </span>
                  </div>
                  <ul>
                    <li
                      :key="index"
                      v-for="(ele, index) in sessionDetails.offerAndPricing
                        .individualSession.abstract"
                    >
                      <v-icon>mdi-check</v-icon>{{ ele }}
                    </li>
                  </ul>
                  <div class="div-selectSession">
                    <v-select
                      height="42px"
                      v-model="selectedSession"
                      :items="selectSessionList"
                      item-text="session_title"
                      outlined
                      return-object
                      placeholder="Select Session"
                    ></v-select>
                  </div>
                  <!-- <div class="div-selectedSelectedSession">
                    <span class="span-selectedSession"> {{
                      selectedSession
                    }} </span>
                  </div> -->
                </div>
                <v-card-actions>
                  <v-btn
                    depressed
                    class="btn-payAndEnroll"
                    :loading="buySessionLoading"
                    @click="
                      () => {
                        buySessionLoading = true;
                        enrollForSession();
                      }
                    "
                  >
                    Pay & Enroll
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-divider
              class="showInMobileView"
              style="border: 1px solid rgba(0, 0, 0, 0.16)!important;"
            >
            </v-divider>
          </v-col>
        </v-row>
      </v-container>
      <v-dialog v-model="dialog" max-width="501">
        <v-card>
          <v-card-title>
            <div
              style="font-weight: 800;font-size: 22px;line-height: 32px;color: #5C658B;"
            >
              Sorry this session is only available for parents
            </div>
            <!--          <v-spacer></v-spacer>-->
            <!--          <v-btn tile large color="#5C658B" icon @click="dialog = false">-->
            <!--            <v-icon>mdi-close</v-icon>-->
            <!--          </v-btn>-->
          </v-card-title>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="indigo accent-3"
              style="width:100px;"
              dark
              :to="{
                name: routerPath.auth.children.eblityLogin.name,
              }"
            >
              <span class="signup-btn-text"> Ok </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
  import store from "@/store";
  import AmplitudeHelper from "@/amplitude";
  import ShareHelper from "@/helper/share";
  import { ROUTER_URL } from "@/constants/urls";
  import helper from "@/helper";

  import authToken from "../../../../common/authToken";

  import Keys from "../../../../constants/keys";

  import CommonApiHelper from "../../../../api/common/CommonApis";
  import SessionSeriesApiHelper from "../../../../api/common/SessionSeriesApi";

  export default {
    name: "DetailSection",
    props: ["details"],
    // metaInfo() {
    //   return {
    //     htmlAttrs: {
    //       Eblity: "Session",
    //     },
    //     headAttrs: {
    //       nest: "Session",
    //     },
    //     meta: [
    //       { charset: "utf-8" },
    //       {
    //         name: "og:description",
    //         content: this.details.sub_heading,
    //       },
    //       {
    //         name: "twitter:description",
    //         content: this.details.sub_heading,
    //       },
    //       {
    //         name: "description",
    //         content: this.details.sub_heading,
    //       },
    //       {
    //         name: "og:title",
    //         content: this.details.title,
    //       },
    //       {
    //         name: "twitter:title",
    //         content: this.details.title,
    //       },
    //       {
    //         name: "title",
    //         content: this.details.title,
    //       },
    //       {
    //         name: "og:image",
    //         content: this.details.thumbnail_path,
    //       },
    //       {
    //         name: "twitter:image",
    //         content: this.details.thumbnail_path,
    //       },
    //       {
    //         name: "image",
    //         content: this.details.thumbnail_path,
    //       },
    //       { name: "og:site_name", content: "Eblity" },
    //       { name: "twitter:site", content: "@Eblity_" },
    //       { name: "twitter:creator", content: "@Eblity_" },
    //     ],
    //   };
    // },
    components: {},
    data() {
      return {
        transaction_id: -1,
        selectedSession: null,
        paymentLoading: false,
        logo: require("@/assets/EblityLogo.png"),
        whatsappUrl: "",
        buySessionLoading: false,
        buySessionSeriesLoading: false,
        dialog: false,
        routerPath: ROUTER_URL,
      };
    },
    created() {},
    computed: {
      selectSessionList() {
        return this.details.session_list.filter(
          (session) => session.can_be_bought_individually
        );
      },
      sessionDetails() {
        var session_list = [];

        this.details.session_list.forEach((element) => {
          session_list.push({
            title: element.session_title,
            dates: helper.formatDate(element.date) + " " + element.time,
            abstract: element.session_abstract,
            thumbnailPath: element.thumbnail_path,
          });
        });

        return {
          is_free: this.details.is_free,
          id: this.details.id,
          headerImage: this.details.thumbnail_path,
          dateToFrom: this.getFormattedDate(),
          title: this.details.title,
          subTitle: this.details.sub_heading,
          detail: this.details.take_aways,
          educatorName: this.details.conductor_details.user_details
            ? this.details.conductor_details.user_details.name
            : "",
          educatorImage: this.details.speaker_image
            ? this.details.speaker_image
            : "",
          educatorBio: this.details.speaker_bio ? this.details.speaker_bio : "",
          skills: this.details.skills,
          ageGroup: this.details.age_groups,
          tags: this.details.tags,
          price: this.details.amount,
          hostedBy: this.details.conductor_details.user_details
            ? this.details.conductor_details.user_details.name
            : "",
          sessionsList: session_list,
          offerAndPricing: {
            allSessions: {
              title: "All " + this.details.session_list.length + " Session",
              price: this.details.amount,
              abstract: [
                "Why communication is important for a child with DS?",
                "How to reduce the gap for communication development milestones?",
                "Why early intervention is critical?",
                "Strategies",
                "Resources",
              ],
            },
            individualSession: {
              title: "Individual Session",
              price: this.details.individual_amount,
              abstract: [
                "Why communication is important for a child with DS?",
                "Why communication is important for a child with DS?",
                "How to reduce the gap for communication development milestones?",
              ],
            },
            sessionList: session_list,
          },
        };
      },
    },
    watch: {},
    methods: {
      getFormattedDate() {
        return (
          helper.formatDate(this.details.start_date_time) +
          " - " +
          helper.formatDate(this.details.end_date_time)
        );
      },
      copyParentLink() {
        var text = window.location.href;
        let props = this.$router.resolve({
          name: ROUTER_URL.publicSession.children.sessionDetails.name,
          params: { id: this.details.id },
        });
        console.log(props);
        text = window.location.origin + props.href;

        // text = text.replace("app", "parent");

        var dummy = document.createElement("input");
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand("copy");
        document.body.removeChild(dummy);
        store.dispatch("snackBar/showToast", {
          message: "Share link copied.",
          color: "S",
        });
      },
      facebookShare() {
        AmplitudeHelper.registerEvent(
          "Session - Share - Facebook",
          this.sessionDetails //TO-DO needs to change as per current page.
        );
        ShareHelper.onFacebook({
          link: this.makePublicLink(),
          text:
            "Have you registered for this session by Eblity? - Click on the link below to save your spot. \n\n",
        });
      },
      twitterShare() {
        AmplitudeHelper.registerEvent(
          "Session - Share - Twitter",
          this.sessionDetails //TO-DO needs to change as per current page.
        );

        ShareHelper.onTwitter({
          url: this.makePublicLink() + "\n\n",
          text:
            "Have you registered for this session by Eblity? - Click on the link below to save your spot. \n\n",
          tag: "Sessions",
        });
      },
      emailShare() {
        AmplitudeHelper.registerEvent(
          "Session - Share - Email",
          this.sessionDetails //TO-DO needs to change as per current page.
        );
        window.location =
          "mailto:?body=Have you registered for this session by Eblity? - Click on the link below to save your spot. " +
          this.makePublicLink() +
          "&subject=I thought this link might interest you.";
      },
      makePublicLink() {
        let props = this.$router.resolve({
          name: ROUTER_URL.publicSession.children.sessionDetails.name,
          params: { id: this.details.id },
        });
        return window.location.origin + props.href;
      },
      enrollForSession() {
        this.$store.state.payment.sessionDetails = this.sessionDetails;
        AmplitudeHelper.registerEvent(
          "Session - Enroll - Click",
          this.sessionDetails //TO-DO needs to change as per current page.
        );
        var requestParams = {};
        this.$store.state.payment.sessionSeriesId = this.details.id;
        this.$store.state.payment.sessions = [];
        this.$store.state.payment.discription = this.details.title;
        this.$store.state.payment.amount = this.details.amount;

        requestParams[Keys.SESSION_SERIES_ID] = this.details.id;

        if (this.selectedSession) {
          this.$store.state.payment.amount = this.details.individual_amount;
          requestParams[Keys.SESSIONS] = [this.selectedSession.id];
          this.$store.state.payment.sessions = [this.selectedSession.id];
        } else {
          this.$store.state.payment.amount = this.details.amount;
          requestParams[Keys.SESSIONS] = [];
          this.$store.state.payment.sessions = [];
        }

        if (authToken.isCorrectAccessToken()) {
          console.log("STEP--1");
          var self = this;

          self.paymentLoading = true;

          //Check Student Count if  < 0 goto Add Student else if  =1 add directy or show list of  >1
          const studentListSuccessHandler = (res) => {
            self.paymentLoading = false;
            if (res.data.data.length == 1) {
              self.$store.state.payment.studentId = res.data.data[0].id;
              SessionSeriesApiHelper.enrollForSessionSeries(
                self.sessionDetails
              );
            } else if (res.data.data.length > 1) {
              //TODO: Figure out this condition -- Show popup
              self.$store.state.payment.studentId = res.data.data[0].id;
              self.dialog = true;
            } else {
              self.$router.push({
                name: ROUTER_URL.enrollAuth.children.studentAdd.name,
              });
            }
          };

          const studentListFailureHandler = (res) => {
            console.log(res);
            self.paymentLoading = false;
          };
          self.paymentLoading = true;
          CommonApiHelper.getAllStudents(
            studentListSuccessHandler,
            studentListFailureHandler
          );
        } else {
          this.$router.push({
            name: ROUTER_URL.enrollAuth.children.signup.name,
          });
        }
      },
    },
    mounted() {
      this.whatsappUrl =
        "whatsapp://send?text=Have you registered for this session by Eblity? - Click on the link below to save your spot. \n\n" +
        window.location.href;
    },
  };
</script>

<style lang="scss" scoped>
  @import "css/DetailSectionStyle";
</style>
<style>
  .contentOverflow img {
    width: 100%;
  }
</style>
